import React, { useState } from "react";
import Page from "../../organisms/Page";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import { Row, Col, Card, Form, Button, Spinner } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";
import styled from "styled-components";
import {
  MascotaDesertora,
  useDescargarMascotasDesertoras,
  useObtenerMascotasDesertoras,
} from "../../../services/analisisOperaciones";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { downloadBlob } from "../../../utils/downloadUtils";
import MascotasDesertorasTable from "./MascotasDesertorasTable";

const breadCrumbs: BreadCrumbItem[] = [
  { path: "/", label: "Inicio" },
  { path: "/analisis", label: "Análisis" },
  { path: "/analisis/operaciones", label: "Operaciones" },
  {
    path: "/analisis/operaciones/guarderia/mascotas-desertoras",
    label: "Mascotas desertoras",
    isActive: true,
  },
];

function MascotasDesertoras() {
  const [itemsPorPagina, setItemsPorPagina] = useState(10);

  const { data, isLoading, error } = useObtenerMascotasDesertoras();
  const descargaMascotasDesertorasMutacion = useDescargarMascotasDesertoras();

  const mascotasDesertoras: MascotaDesertora[] = data || [];

  const descargarExcel = async () => {
    const respuesta = await descargaMascotasDesertorasMutacion.mutateAsync();
    const nombreArchivo = respuesta.nombre
      ? `${respuesta.nombre}${respuesta.extension ? `.${respuesta.extension}` : ""}`
      : "mascotas_desertoras.xlsx";
    downloadBlob(respuesta.contenido, nombreArchivo);
  };

  if (error) {
    return <ServerErrorModal />;
  }

  return (
    <Page
      title="Mascotas desertoras"
      description="Mascotas que dejaron de agendar planes de Guardería."
      breadCrumbs={breadCrumbs}
    >
      <LoadingScreen isLoading={isLoading} />
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={9} xxl={8}>
          <StyledCard>
            <Card.Body>
              <Row className="mb-3">
                <Col xs={12} md={4}>
                  <Form.Group controlId="itemsPorPagina">
                    <Form.Label>Items por página</Form.Label>
                    <Form.Select
                      value={itemsPorPagina}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                        setItemsPorPagina(parseInt(e.target.value))
                      }
                    >
                      {[5, 10, 15].map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                          {pageSize}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={8} className="d-flex align-items-end justify-content-md-end mt-3 mt-md-0">
                  <Button
                    variant="primary"
                    onClick={descargarExcel}
                    disabled={descargaMascotasDesertorasMutacion.isLoading}
                  >
                    {descargaMascotasDesertorasMutacion.isLoading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Descargando...
                      </>
                    ) : (
                      <>
                        <DownloadIcon sx={{ fontSize: 20, marginRight: "8px" }} />
                        Descargar
                      </>
                    )}
                  </Button>
                </Col>
              </Row>

              <MascotasDesertorasTable
                mascotasDesertoras={mascotasDesertoras}
                isLoading={isLoading}
                itemsPorPagina={itemsPorPagina}
              />
            </Card.Body>
          </StyledCard>
        </Col>
      </Row>
    </Page>
  );
}

const StyledCard = styled(Card)`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export default MascotasDesertoras;
